import App from './components/App';
import { AppContainer } from 'react-hot-loader';
import { initializeIcons } from '@fluentui/react';
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import officeApi from '../api/officeApi';
import { retrieveDataForAppInitialization } from '../taskpane/utils/init';

initializeIcons();

const store = configureStore();

const renderApp = (Component) => {
  render(
      <Provider store={store}>
        <AppContainer>
          <Component />
        </AppContainer>
      </Provider>,
      document.getElementById('container'),
  );
};

officeApi.onReady(() => {
  return retrieveDataForAppInitialization(store.dispatch);
});

/* Initial render */
renderApp(App);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default;
    renderApp(NextApp);
  });
}
